<template>
  <div v-if="dialogVisible" class="cv-grade-cover" style="z-index:1050">
    <div class="cv-grade">
      <CvGradeInner v-if="dialogVisible" ref="CvGradeInner" @confirm="this.dialogVisible = false"></CvGradeInner>
    </div>
  </div>
</template>
<script>
import CvGradeInner from './CvGradeInner.vue'

export default {
  components: { CvGradeInner },
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    async open(cv) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.CvGradeInner.open(cv)
      })
    },
  },
}
</script>
<style scoped>
.cv-grade-cover {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  overflow: auto;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  padding-bottom: 100px;
}
.cv-grade {
  width: 700px;
  background-color: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 0 0 5px 0 #d0d0d0;
  box-shadow: 0 0 5px 0 #d0d0d0;
  padding: 20px 30px;
  align-self: baseline;
  position: relative;
}
.cv-grade-header {
  border-bottom: 1px solid #000;
  display: flex;
  padding-bottom: 10px;
}
.cv-grade-content {
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
}
.cv-header-left {
  margin-right: 10px;
  flex: none;
  font-size: 24px;
  padding: 10px 20px;
  border: 2px solid #000;
  border-radius: 4px;
}
.cv-header-right {
  flex: auto;
  font-size: 24px;
  padding: 9px 20px;
  border: 2px solid #c1c1c1;
  color: #cbcbcb;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cv-header-right .name {
  font-size: 20px;
  color: #000;
}
.cv-grade-title {
  font-size: 16px;
  font-weight: 700;
}
.cv-grade-detail {
  display: flex;
  padding-left: 40px;
  font-size: 14px;
}
.detail-label {
  flex: none;
  display: inline-block;
  min-width: 100px;
}
.detail-options span {
  margin-right: 30px;
  position: relative;
  color: #999;
}
.detail-options .option-check::after {
  content: '';
  width: 200%;
  height: 173%;
  position: absolute;
  top: -35%;
  left: -21%;
  background-image: url('../../../assets/images/circle.png');
  background-repeat: no-repeat;
  color: black;
  background-size: contain;
}
.cv-level-box {
  position: absolute;
  top: 45px;
  right: 45px;
  width: 120px;
}
.cv-level-box img {
  width: 100%;
}
.cv-grade-result {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.cv-grade-result .grade {
  font-size: 26px;
  font-weight: 600;
}
.cv-choose-category {
  border: 1px solid #bfbfbf;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 14px;
}
.checkbox-box {
  display: flex;
}
.checkbox-label {
  flex: none;
  word-break: keep-all;
  margin-right: 10px;
  font-weight: 700;
}
.category-alert {
  color: #ff9966;
  margin: 10px 0;
  font-size: 12px;
}
.btn-box {
  display: flex;
  justify-content: center;
  padding: 10px;
}
.grade-num {
  font-size: 26px;
  font-weight: 700;
}
.margin-md {
  margin: 5px;
}
.word-break-class {
  height: unset !important;
  white-space: pre-wrap !important;
}
</style>
